import { siteData } from '@/mocks/siteData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-question-line"></i>常见问题
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            关于黑料，你想知道的都在这里
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            新来的吃瓜群众？先看看这些问题
          </p>
        </div>

        <div className="space-y-4">
          {siteData.faq.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden"
            >
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-add-line group-open:ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}